import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import {
  RestaurantKitchenOrderDTO,
  RestaurantKitchenOrderFilters,
} from '../../../types/restaurant/RestaurantKitchenOrderTypes';
import { RestaurantPreparationStationDTO } from '../../../types/restaurant/RestaurantPreparationStationTypes';

interface State {
  list: RestaurantKitchenOrderDTO[];
  stations: RestaurantPreparationStationDTO[];
  filters: RestaurantKitchenOrderFilters;
  loading: boolean;
  refreshing: boolean;
  actionKey: string | null;
  lastUpdatedAt: string | null;
}

const initialState: State = {
  list: [],
  stations: [],
  filters: { stationId: '', status: '' },
  loading: false,
  refreshing: false,
  actionKey: null,
  lastUpdatedAt: null,
};

const slice = createSlice({
  name: 'restaurantKitchenOrder',
  initialState,
  reducers: {
    setKitchenOrders(
      state,
      action: PayloadAction<RestaurantKitchenOrderDTO[]>
    ) {
      state.list = action.payload;
      state.lastUpdatedAt = new Date().toISOString();
    },
    replaceKitchenOrder(
      state,
      action: PayloadAction<RestaurantKitchenOrderDTO>
    ) {
      const index = state.list.findIndex(
        (item) => item.id === action.payload.id
      );
      if (index >= 0) state.list[index] = action.payload;
      else state.list.unshift(action.payload);
      state.lastUpdatedAt = new Date().toISOString();
    },
    setKitchenStations(
      state,
      action: PayloadAction<RestaurantPreparationStationDTO[]>
    ) {
      state.stations = action.payload;
    },
    setKitchenLoading(state, action: PayloadAction<boolean>) {
      state.loading = action.payload;
    },
    setKitchenRefreshing(state, action: PayloadAction<boolean>) {
      state.refreshing = action.payload;
    },
    setKitchenActionKey(state, action: PayloadAction<string | null>) {
      state.actionKey = action.payload;
    },
    setKitchenFilter<K extends keyof RestaurantKitchenOrderFilters>(
      state: State,
      action: PayloadAction<{
        field: K;
        value: RestaurantKitchenOrderFilters[K];
      }>
    ) {
      state.filters = {
        ...state.filters,
        [action.payload.field]: action.payload.value,
      };
    },
    resetKitchenBoard(state) {
      state.list = [];
      state.stations = [];
      state.filters = { stationId: '', status: '' };
      state.lastUpdatedAt = null;
    },
  },
});

export const {
  setKitchenOrders,
  replaceKitchenOrder,
  setKitchenStations,
  setKitchenLoading,
  setKitchenRefreshing,
  setKitchenActionKey,
  setKitchenFilter,
  resetKitchenBoard,
} = slice.actions;
export default slice.reducer;
